(function () {
  document.querySelectorAll('[data-hr-product]').forEach(initProduct);

  // MAPA DE COLORES REALES
  var HR_COLOR_MAP = {
    'rojo': '#C0392B', 'azul': '#2E5FA3', 'verde': '#2E7D4F', 'negro': '#1A1A1A',
    'blanco': '#FFFFFF', 'gris': '#9B9B93', 'amarillo': '#F1C40F', 'rosa': '#E58EB5',
    'marron': '#6B4A34', 'marrón': '#6B4A34', 'morado': '#7D4A9E', 'lila': '#B39DDB',
    'naranja': '#E07B39', 'turquesa': '#1FA6A0', 'dorado': '#C9A34E', 'plateado': '#B8BCC2',
    'beige': '#D8CBB0', 'crema': '#F1E9D8', 'granate': '#7B1F2B', 'burdeos': '#7B1F2B',
    'azul marino': '#1E2A4A', 'marino': '#1E2A4A', 'verde oliva': '#6B7A3A', 'oliva': '#6B7A3A',
    'coral': '#F08A6C', 'fucsia': '#E4197C', 'celeste': '#8ECBE0', 'menta': '#9FD8C4',
    'salmon': '#F4A688', 'salmón': '#F4A688', 'khaki': '#B7A87C', 'caqui': '#B7A87C'
  };

  function paintColorSwatches(root) {
    root.querySelectorAll('[data-color-name]').forEach(function (swatch) {
      var name = swatch.getAttribute('data-color-name').toLowerCase().trim();
      var hex = HR_COLOR_MAP[name];
      if (hex) {
        swatch.style.background = hex;
        if (hex.toLowerCase() === '#ffffff') swatch.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.25)';
      } else {
        swatch.setAttribute('data-unknown-color', '');
        swatch.textContent = name.slice(0, 3);
      }
    });
  }

  function initProduct(root) {
    paintColorSwatches(root);
    initGallery(root);
    initZoom(root);
    initVariants(root);
    initQty(root);
    initFileFields(root);
    initAccordion(root);
    initAddToCart(root);
    initStickyBar(root);
    initRelated(root);
  }

  // GALERÍA
  function initGallery(root) {
    const main = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.getAttribute('data-full');
      });
    });
  }

  // ZOOM (hover/click con paneo)
  function initZoom(root) {
    const container = root.querySelector('[data-zoom-container]');
    const img = root.querySelector('[data-main-image]');
    if (!container || !img) return;

    container.addEventListener('click', function () {
      container.classList.toggle('is-zoomed');
    });
    container.addEventListener('mousemove', function (e) {
      if (!container.classList.contains('is-zoomed')) return;
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
    container.addEventListener('mouseleave', function () {
      container.classList.remove('is-zoomed');
    });
  }

  // VARIANTES
  function initVariants(root) {
    const variants = window.hrProductVariants || [];
    const optionNames = window.hrProductOptions || [];
    const variantInput = root.querySelector('[data-variant-id]');
    const priceEl = root.querySelector('[data-price] .hr-product__price-current');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const addLabel = root.querySelector('[data-add-label]');

    const selected = {};
    root.querySelectorAll('[data-option-value].is-selected').forEach(function (btn) {
      selected[btn.getAttribute('data-option-index')] = btn.getAttribute('data-value');
    });

    root.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const idx = btn.getAttribute('data-option-index');
        const group = root.querySelectorAll('[data-option-value][data-option-index="' + idx + '"]');
        group.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[idx] = btn.getAttribute('data-value');

        const optionDiv = btn.closest('.hr-product__option');
        const label = optionDiv && optionDiv.querySelector('[data-color-label]');
        if (label) label.textContent = btn.getAttribute('data-value');

        updateVariant();
      });
    });

    function updateVariant() {
      const values = optionNames.map(function (_, i) { return selected[i]; });
      const match = variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (opt, i) {
          return values[i] === undefined || opt === values[i];
        });
      });
      if (!match) return;

      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

      if (addBtn) {
        addBtn.disabled = !match.available;
        addLabel.textContent = match.available ? 'Añadir al carrito' : 'Agotado';
      }

      if (match.featured_image) {
        const main = root.querySelector('[data-main-image]');
        if (main) main.src = match.featured_image.src.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_1200x$1$2');
      }
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  // CANTIDAD
  function initQty(root) {
    const input = root.querySelector('[data-qty-input]');
    if (!input) return;
    root.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
    });
    root.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
  }

  // CAMPOS DE IMAGEN: preview y quitar
  function initFileFields(root) {
    root.querySelectorAll('[data-file-field]').forEach(function (field) {
      const input = field.querySelector('[data-file-input]');
      const label = field.querySelector('[data-file-label]');
      const preview = field.querySelector('[data-file-preview]');
      const previewImg = field.querySelector('[data-file-preview-img]');
      const fileName = field.querySelector('[data-file-name]');
      const removeBtn = field.querySelector('[data-file-remove]');

      input.addEventListener('change', function () {
        const file = input.files && input.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = function (e) {
          previewImg.src = e.target.result;
          fileName.textContent = file.name;
          preview.hidden = false;
          label.hidden = true;
        };
        reader.readAsDataURL(file);
      });

      removeBtn.addEventListener('click', function () {
        input.value = '';
        preview.hidden = true;
        label.hidden = false;
      });
    });
  }

  // ACORDEÓN
  function initAccordion(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const item = trigger.closest('.hr-accordion__item');
        const panel = item.querySelector('[data-accordion-panel]');
        const isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open', !isOpen);
        panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
      });
    });
  }

  // AÑADIR AL CARRITO (AJAX, o envío normal si hay ficheros adjuntos)
  function initAddToCart(root) {
    const form = root.querySelector('[data-hr-form]');
    if (!form) return;
    const message = root.querySelector('[data-add-message]');

    form.addEventListener('submit', function (e) {
      const fileInputs = form.querySelectorAll('input[type="file"]');
      const hasFile = Array.prototype.some.call(fileInputs, function (input) {
        return input.files && input.files.length > 0;
      });

      // Si hay una imagen adjunta, dejamos que el navegador envíe el formulario
      // de forma normal (Shopify no admite ficheros por AJAX en /cart/add.js).
      if (hasFile) {
        if (message) message.textContent = 'Subiendo y añadiendo al carrito…';
        return;
      }

      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (message) message.textContent = '✓ Añadido al carrito';
          document.dispatchEvent(new CustomEvent('hr:cart:added'));
          setTimeout(function () { if (message) message.textContent = ''; }, 3000);
        })
        .catch(function () {
          if (message) message.textContent = 'No se pudo añadir, inténtalo de nuevo.';
        });
    });
  }

  // BARRA STICKY
  function initStickyBar(root) {
    const bar = root.querySelector('[data-sticky-bar]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const stickyAddBtn = root.querySelector('[data-sticky-add]');
    if (!bar || !addBtn) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(addBtn);

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        addBtn.click();
      });
    }
  }

  // RELACIONADOS
  function initRelated(root) {
    const container = root.querySelector('[data-related-products]');
    if (!container) return;
    const track = container.querySelector('[data-related-track]');
    const productId = container.getAttribute('data-product-id');

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const products = (data && data.products) || [];
        if (!products.length) {
          container.style.display = 'none';
          return;
        }
        track.innerHTML = products.map(function (p) {
          const img = p.featured_image || (p.images && p.images[0]);
          return '<a class="hr-related-card" href="' + p.url + '">' +
            '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
            '<p class="hr-related-card__title">' + escapeHtml(p.title) + '</p>' +
            '<p class="hr-related-card__price">' + formatMoney(p.price) + '</p>' +
            '</a>';
        }).join('');
      })
      .catch(function () { container.style.display = 'none'; });

    const prev = container.querySelector('[data-related-prev]');
    const next = container.querySelector('[data-related-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -240, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: 240, behavior: 'smooth' }); });
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }
})();
